import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "flex flex-row flex-wrap" }

import InputTextWithSubmit from "@/components/Form/Common/InputTextWithSubmit.vue";
import PlayerItem from "@/components/Game/PlayerItem.vue";
import PrimaryLabel from "@/components/Form/Common/PrimaryLabel.vue";
import { useGameStore } from "@/Store/useGameStore";
import { computed, ComputedRef } from "vue";
import { defineProps } from "vue/dist/vue";
import ErrorText from "@/components/Texts/ErrorText.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'EditPlayers',
  props: {
    displayErrors: { type: Boolean }
  },
  setup(__props: any) {

const gameStore = useGameStore();

const props = __props;

const players: ComputedRef<string[]> = computed(() => {
  return gameStore.players;
});

const submitFunction = (name: string): void => {
  gameStore.addPlayer(name);
};

const errors = computed(() => {
  return gameStore.errors;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PrimaryLabel, {
      text: "Joueurs :",
      class: "mb-2 text-left"
    }),
    _createVNode(InputTextWithSubmit, {
      id: "player-name",
      name: "player-name",
      placeholder: "Joueur",
      is_required: true,
      function: submitFunction
    }),
    (props.displayErrors)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createVNode(ErrorText, {
                text: error.message,
                class: "mt-2"
              }, null, 8, ["text"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(players.value, (player) => {
        return (_openBlock(), _createBlock(PlayerItem, {
          key: player,
          name: player,
          class: "mb-4 mr-4"
        }, null, 8, ["name"]))
      }), 128))
    ])
  ]))
}
}

})